export const mainLinks = [
    { href: 'https://www.meucupom.com/', label: 'Página Inicial' },
    { href: '/lojas', label: 'Lojas' },
    { href: '/categorias', label: 'Categorias' },
    { href: '/devolve', label: 'Meu Cupom Devolve' },
    { href: 'https://www.meucupom.com/meucupom-alerta', label: 'Meu Cupom Alerta' },
    { href: 'https://blog.meucupom.com/', label: 'Blog' },
    { href: '/', label: 'Meu Cupom Clubes' },
]